export default __webpack_public_path__ + "static/media/challenge-success-video-game-6346.5f1fee46.mp3";